import React from 'react';
interface ArticleCardProps {
  imageUrl?: string;
  title?: string;
  description?: string;
  category?: string;
  hasShadow?: boolean;
  index?: number;
}
export function ArticleCard({
  imageUrl,
  title = 'The US agencies storming up the World Creative Rankings',
  description = "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category = 'NEWS',
  hasShadow = false
}: ArticleCardProps) {
  const hasImage = imageUrl && imageUrl !== '#D9D9D9';
  return <div className="flex flex-col group cursor-pointer w-full" data-id="element-6">
      <div className="w-full overflow-hidden" style={{
      aspectRatio: '430/225',
      backgroundColor: '#D9D9D9',
      boxShadow: hasShadow ? 'inset 0px 4px 4px rgba(0,0,0,0.25)' : undefined
    }} data-id="element-7">
        {hasImage && <img src={imageUrl} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-8" />}
      </div>
      {/* Title + excerpt card overlaps image via negative margin, stays in flow */}
      <div className="mx-[8%] relative z-10" style={{
      marginTop: '-40px'
    }} data-id="element-9">
        <div className="bg-white" style={{
        padding: '16px 20px 16px 20px'
      }} data-id="element-10">
          <h3 className="font-bold" style={{
          color: '#6B6B6B',
          fontSize: 'clamp(16px, 1.5vw, 20px)',
          fontFamily: 'League Gothic',
          fontWeight: 700,
          lineHeight: 'normal'
        }} data-id="element-11">
            {title}
          </h3>
          <p className="line-clamp-3 mt-2" style={{
          color: '#6B6B6B',
          fontSize: '15px',
          fontFamily: 'League Gothic',
          fontWeight: 400,
          lineHeight: 'normal'
        }} data-id="element-12">
            {description}
          </p>
        </div>
      </div>
      <div className="px-4 lg:px-5" style={{
      marginTop: '12px'
    }} data-id="element-13">
        <span className="inline-block font-bold uppercase cursor-pointer transition-colors duration-200 hover:bg-gray-50" style={{
        border: '1px solid #6B6B6B',
        padding: '4px 16px',
        color: '#6B6B6B',
        fontSize: '15px',
        fontFamily: 'League Gothic',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '0.1em'
      }} data-id="element-14">
          {category}
        </span>
      </div>
    </div>;
}